import HttpRequest from './core/http_request';
import authModule from '../store/auth_module';

class PublicProvider extends HttpRequest {
  constructor () {
    super();
    this.pathName = (authModule.state.loggedIn) ? '/private' : '/public';
  }

  getStatus () {
    return this.request('get', '/status');
  }

  // common
  getProvince () {
    return this.request('get', '/public/common/province');
  }

  getAmphur (data) {
    return this.request('get', '/public/common/amphur/' + data.provinceID);
  }

  getTambon (data) {
    return this.request('get', '/public/common/tambon/' + data.amphurID);
  }

  getMasterWaterSupplyList (data) {
    return this.request('get', '/public/masterWaterSupply', data);
  }

  getMasterWaterSupplyById (data) {
    return this.request('get', '/public/masterWaterSupply/id/' + encodeURIComponent(data._id));
  }

  createWaterSupplySurvey (data) {
    return this.request('post', '/public/survey/waterSupply', data);
  }

  createWaterSupplySample (data) {
    return this.request('post', '/public/survey/waterSupplySample', data);
  }

  generateWaterSupplySampleCode (data) {
    return this.request('post', '/public/runningCodeWaterSupply/generate', data);
  }

  // kokwatch
  saveWaterUsageSurvey (data) {
    return this.request('post', '/public/survey/waterUsage', data);
  }

  getWaterUsageList (data) {
    return this.request('get', '/public/survey/waterUsage', data);
  }

  getWaterUsageSurvey (data) {
    return this.request('get', '/public/survey/waterUsage/id/' + data.id);
  }

  updateWaterUsageSurvey (data) {
    const id = data.id;
    delete data.id;
    return this.request('post', '/public/survey/waterUsage/id/' + id, data);
  }

  deleteWaterUsageSurvey (data) {
    return this.request('post', '/public/survey/waterUsage/delete/id/' + data.id);
  }

  getWaterUsageReport () {
    return this.request('get', '/public/survey/waterUsage/report');
  }

  // end kokwatch

  // agra
  // waterQuality
  getWaterQualityList (data) {
    return this.request('get', '/public/survey/waterQuality', data);
  }
  // end waterQuality

  // soundMeasurement
  // saveSoundMeasurement (data) {
  //   return this.request('post', '/public/survey/soundMeasurement', data);
  // }

  getSoundMeasurementList (data) {
    return this.request('get', '/public/survey/soundMeasurement', data);
  }

  // getSoundMeasurement (data) {
  //   return this.request('get', '/public/survey/soundMeasurement/id/' + data.id);
  // }

  // updateSoundMeasurement (data) {
  //   const id = data.id;
  //   delete data.id;
  //   return this.request('post', '/public/survey/soundMeasurement/id/' + id, data);
  // }

  // deleteSoundMeasurement (data) {
  //   return this.request('post', '/public/survey/soundMeasurement/delete/id/' + data.id);
  // }
  // end agra

  // questionnaire
  generateSampleCode (data) {
    return this.request('post', '/public/common/runningCode/generate', data);
  }

  getEnvHeavyMetalSurveyList (data) {
    return this.request('get', '/public/ncid/survey/envHeavyMetal/list', data);
  }

  saveEnvHeavyMetalSurvey (data) {
    const funcName = data.funcName;
    delete data.funcName;
    return this.request('post', `/public/ncid/survey/${funcName}`, data);
  }
}

export default PublicProvider;
